import { render, staticRenderFns } from "./OrderResult.vue?vue&type=template&id=29c82e7c&"
import script from "./OrderResult.vue?vue&type=script&lang=js&"
export * from "./OrderResult.vue?vue&type=script&lang=js&"
import style0 from "./OrderResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports